// GENERATED by tools/make-treeatlas.mjs — do not edit by hand.
// Cell UV rectangles into public/tex/trees.png, v from the bottom.
export interface AtlasCell {
  u0: number; v0: number; u1: number; v1: number
  /** Width over height of the trimmed subject, for sizing cards. */
  aspect: number
}

export const TREE_ATLAS: Record<
  'ghost' | 'spruce' | 'spar' | 'branchHeavy' | 'branchMedium' | 'branchSparse' | 'white',
  AtlasCell
> = {
  "ghost": {
    "u0": 0.06402091628248113,
    "v0": 0.31640625,
    "u1": 0.26801033371751887,
    "v1": 1,
    "aspect": 0.29840737636211234
  },
  "spruce": {
    "u0": 0.333984375,
    "v0": 0.31640625,
    "u1": 0.666015625,
    "v1": 0.9880281304728546,
    "aspect": 0.49437229437229435
  },
  "spar": {
    "u0": 0.6988620074020017,
    "v0": 0.31640625,
    "u1": 0.9691067425979983,
    "v1": 1,
    "aspect": 0.39532944120100083
  },
  "branchHeavy": {
    "u0": 0,
    "v0": 0.0703125,
    "u1": 0.33203125,
    "v1": 0.21830669202302633,
    "aspect": 2.243542435424354
  },
  "branchMedium": {
    "u0": 0.333984375,
    "v0": 0.0703125,
    "u1": 0.666015625,
    "v1": 0.1831916360294118,
    "aspect": 2.94147582697201
  },
  "branchSparse": {
    "u0": 0.66796875,
    "v0": 0.0703125,
    "u1": 1,
    "v1": 0.19009767248545306,
    "aspect": 2.771889400921659
  },
  "white": {
    "u0": 0.0234375,
    "v0": 0.0234375,
    "u1": 0.0234375,
    "v1": 0.0234375,
    "aspect": 1
  }
}
